// extracted by mini-css-extract-plugin
export default {"taskSummaryText":"TaskGridSummary_taskSummaryText__rY-JD","taskSummaryIcon":"TaskGridSummary_taskSummaryIcon__o8jdP"};